import { render, staticRenderFns } from "./AvailableTimeSlots.vue?vue&type=template&id=72ed89f6&"
import script from "./AvailableTimeSlots.vue?vue&type=script&lang=js&"
export * from "./AvailableTimeSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports